import MaintenanceDashboardGrid from './maintenance-dashboard-grid';
export * from './maintenance-dashboard-grid';

export default MaintenanceDashboardGrid;
